export const VIEWPORT_MODES = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
}

// Hover intent: the open delay keeps a pointer passing over a tab from opening
// its menu, and the close delay lets the pointer cross neighboring tabs or
// small gaps on its way into an open menu.
export const HOVER_OPEN_DELAY_MS = 100
export const HOVER_CLOSE_DELAY_MS = 200

export const ITEM_KINDS = {
  link: 'link',
  sectionLabel: 'sectionLabel',
}
